export default __webpack_public_path__ + "static/media/you-won-war-page.0b94df8a.png";